import { themes } from '@olist/design-system-tokens';

export const breakpoints = {
  xsmall: '380px',
  small: themes.olist.base.breakpoints.small,
  medium: themes.olist.base.breakpoints.medium,
  large: themes.olist.base.breakpoints.large,
  xlarge: themes.olist.base.breakpoints['1xlarge'],
};

const devices = {
  xsmall: `@media screen and (max-width: ${breakpoints.xsmall})`,
  small: `@media screen and (min-width: ${breakpoints.xsmall}) and (max-width: ${breakpoints.small})`,
  medium: `@media screen and (min-width: ${breakpoints.small}) and (max-width: ${breakpoints.medium})`,
  large: `@media screen and (min-width: ${breakpoints.medium}) and (max-width: ${breakpoints.large})`,
  xlarge: `@media screen and (min-width: calc(${breakpoints.large} + 1px))`,
  mobile: `@media screen and (max-width: ${breakpoints.small})`,
};

export { devices };
